module.exports = __webpack_public_path__ + "img/about-sm.766801be.svg";